import FacilitiesSection from './FacilitiesSection';

export default FacilitiesSection;